
export function _setTurListArray(state, responseData) {
    state.turList = responseData
}

